import { Fragment, h } from '@stencil/core';
import type { ObservableMap } from '@stencil/store';

import type { MatchStoreState } from '../../../../../services/interfaces';
import { HomeAwayTeam } from '../../../../../services/interfaces';
import { getMatchWording, isFutsal, matchFouls, setCssVariant } from '../../helpers';

type Props = {
  state: ObservableMap<MatchStoreState>['state'];
};

const MatchFouls = ({ state }: Props) => {
  const cssVariant = setCssVariant(state.size);
  const match = state.matchData;
  if (!match) return null;

  if (!isFutsal(match) || !match.fouls) return null;

  const homeFouls = matchFouls(match, HomeAwayTeam.HOME) ?? 0;
  const awayFouls = matchFouls(match, HomeAwayTeam.AWAY) ?? 0;

  const printFouls = (count: number) => (
    <Fragment>
      {new Array(5).fill({}).map((_, i) => (
        <li class={{ foul: true, active: i < count }} key={`foul-${i + 1}`}></li>
      ))}
    </Fragment>
  );

  return (
    <div class={{ 'pk-match__fouls': true, ...cssVariant }} part="match-fouls">
      <ul class={{ 'pk-match__fouls--home': true }} part="match-fouls-home">
        {printFouls(homeFouls)}
      </ul>
      <div class="pk-match__fouls--label" part="match-fouls-label">
        {getMatchWording('futsal_foulcounter')}
      </div>
      <ul class={{ 'pk-match__fouls--away': true }} part="match-fouls-away">
        {printFouls(awayFouls)}
      </ul>
    </div>
  );
};

export { MatchFouls };
